<template>
  <training-intro :trainingId="trainingId"/>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import TrainingIntro from '@/components/training/TrainingIntro.vue';
export default {
  name: 'StaffIntroPage',
  components: { TrainingIntro },
  props: [],
  data: () => ({
    trainingId: ''
  }),
  computed: {
    ...mapState('auth', ['profile'])
  },
  watch: {
    profile () {
      this.trainingId = this.profile.training._id
    }
  }
}
</script>
